export default __webpack_public_path__ + "static/media/radio.3c6a578e.svg";